<lib-searchmask [showSearchMask]="showSearchMask" (valueChanged)="setChangeDetected($event)"></lib-searchmask>


<div class="container my-5 position-relative">

    @if (changeDetected){
        <div class="sm-changed-overlay">
            {{"av.SearchChanged"|translate}}
        </div>
    }
    
    @if (!noAvInSomeIndex) {

        <h2 class="my-3">{{'htl.OurHotels'|translate}}</h2>
        <p class="my-2">{{'htl.PleaseSelectAHotel'|translate}}</p>
        
    }


    <!-- If availability is returned -->
    @if (hotels) { 
        
            <!-- Loop through rooms in per multiroom -->
            <div class="hotels-wrapper">
               @for (hotel of hotels; track $index) {
                
                <div class="hotel-container" [class.moreThan2]="hotels.length > 2">

                    <app-image-gallery1 [hotelCode]="hotel.hotelCode" />

                    <div class="hotel-texts">
                        <div class="row">
                            <div class="col-8">
                                <h2 class="hotel-name">{{hotel.name}}</h2>
                            </div>
                            <div class="col-4">
                                <div class="hotel-address">
                                    <div>
                                        {{contactDetails[$index].address}}<br>
                                        {{contactDetails[$index].zipCode}} {{contactDetails[$index].city}}
                                    </div>
                                    @if (contactDetails[$index].latLng) {
                                        <p-button icon="" class="map-button" [rounded]="true" [text]="true" (click)="showMap(contactDetails[$index].latLng)">
                                            <span class="material-symbols-outlined">
                                                map
                                            </span>
                                        </p-button>
                                    }   
                                </div>
                            </div>
                        </div>

                        <div class="hotel-description" [innerHtml]="hotel.shortDescription"></div>

                        <div class="hotel-buttons">
                            <p-button (click)="selectHotel(hotel.hotelCode)">{{'htl.selectHotel'|translate}}</p-button>

                        </div>
                    </div>
                    
                </div>
               }
            </div>        
    }
    @else {
       
        <app-availability-room-1-skeleton />   
        <app-availability-room-1-skeleton />
           
    }
</div>

<p-dialog [header]="'htl.Map'|translate" [modal]="true" [(visible)]="mapDialogVisible" [style]="{ width: '845px', height: '910px'}" (onHide)="closeMap()">
    @if (mapCoordinates) {
        <app-map [coordinates]="mapCoordinates"></app-map>
    }
    
</p-dialog>
